import React from 'react';

const NotFoundPage: React.FC = () => (
    <div style={{ color: 'red' }}>
        <p>Sorry, we were not able to find the page you were looking for.</p>
        <p>Please check the address and try again.</p>
    </div>
);

export default NotFoundPage;
